import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState, ValidationError } from '@reducers/v2/planboard/types';
import { CLOSE_PRODUCTION_OPERATION_ERROR_CODES } from '@v2/components/FinishJobModal/constants';

export const onFailedToCloseProductionOperationAction = (
  state: PlanboardState,
  action: PayloadAction<{ productionOperationId: number; errorMessage?: string; validationErrors?: ValidationError[] }>
) => {
  const snapshot = state.lastClosedSnapshot;
  // JobAlreadyFinished = success-in-disguise; the card should stay removed, no Alert, no rebuild.
  const isAlreadyFinished = action.payload.validationErrors?.some((e) => e.errorCode === CLOSE_PRODUCTION_OPERATION_ERROR_CODES.JOB_ALREADY_FINISHED);

  if (!isAlreadyFinished && snapshot && snapshot.item.productionOperationId === action.payload.productionOperationId) {
    const column = state.machineProductionOperations[snapshot.columnId];
    if (column) {
      const insertAt = Math.min(snapshot.index, column.items.length);
      column.items.splice(insertAt, 0, snapshot.item);
      column.total = column.items.length;
    }
  }
  state.lastClosedSnapshot = null;

  // Don't surface JobAlreadyFinished to Board's lastCloseError consumer — it would Alert + rebuild.
  if (isAlreadyFinished) return;

  state.lastCloseError = {
    productionOperationId: action.payload.productionOperationId,
    errorMessage: action.payload.errorMessage,
    validationErrors: action.payload.validationErrors,
  };
};
